import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  OnInit,
  output,
  signal,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { getMenu } from '@core/customer-menus/menu-utilities';
import { MenuItem } from '@core/models/menu/menu.model';
import { BrowserStorageService } from '@core/utilities/browser-storage/browser-storage.service';
import { MenuItemComponent } from '../menu-item/menu-item.component';
import {AuthService} from '@core/services/auth/auth.service';
import {toSignal} from '@angular/core/rxjs-interop';

@Component({
  selector: 'sqep-custom-sidenav',
  imports: [
    MatListModule,
    MatSidenavModule,
    RouterModule,
    MatIconModule,
    MenuItemComponent,
  ],
  templateUrl: './custom-sidenav.component.html',
  styleUrl: './custom-sidenav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomSidenavComponent implements OnInit {
  private readonly storageService = inject(BrowserStorageService);
  private readonly authService = inject(AuthService);

  protected clientLogoAsset2 = input<string>();
  protected heading = input<string>();
  protected subTitle = input<string>();
  protected applicationName = input<string>();
  protected collapsed = input<boolean>(false);
  protected menuData = signal<MenuItem[]>([]);
  protected profilePicSize = computed(() => (this.collapsed() ? '32' : '64'));
  protected changeCollapsedState = output<boolean>();
  protected selectedMenuItem = signal<string>(
    this.storageService.get('lastSelectedMenuItem'),
  );

  public isLoggedIn = toSignal(this.authService.authenticationStatusSubj);

  ngOnInit(): void {
    this.refreshMenu();
    this.authService.permissionsSubject.subscribe(x => {
      this.refreshMenu();
    });
  }

  private refreshMenu()
  {
    this.menuData.set(
      [...getMenu()]
        .filter((m) => this.showMenuItem(m))
        .map((element) => {
          return {
            ...element,
            subMenu: element.subMenu?.filter((subElement) =>
              this.showMenuItem(subElement)
            ),
          };
        }),
    );
  }

  private showMenuItem(menuItem: MenuItem): boolean {
    if(menuItem.hideItem) { return false; }
    if(menuItem.data === undefined) { return true; }
    const integrationId = menuItem.data?.integrationId;
    const requiredPermission = menuItem.data?.requiredPermission;
    return this.authService.userHasPermission(integrationId, requiredPermission);
  }
}
